<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc1">Contents</h1>
<h2 class="toc2"><a id="page_v"></a><a href="#/xhtml/Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc2"><a href="#/xhtml/Maps"><em class="italic">Map</em></a></h2>
<h2 class="toc-chap1"><a href="#/xhtml/Chapter_1"><span class="toc-chap_float">Chapter 1</span> General Władysław Anders, Origins and the Polish Army, 1892–1939</a></h2>
<h2 class="toc-chap1"><a href="#/xhtml/Chapter_2"><span class="toc-chap_float">Chapter 2</span> 1939–1941: The Division of Poland and Relations with the Soviet Union</a></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_3" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 3</span> Amnesty and Evacuation</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_4" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 4</span> The Formation of Second Polish Corps</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_5" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 5</span> Anders and Sikorski, 1942–1943</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_6" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 6</span> Italy and Monte Cassino</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_7" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 7</span> Italy after Monte Cassino</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_8" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 8</span> 1945–1948: A New Poland and a Divided Europe</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_9" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 9</span> Europe and Poland: Immediate Post-War Problems</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/Chapter_10" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 10</span> The End: 1947–1970</span></h2>
<h2 class="toc2"><span href="#/xhtml/notes" title="Link target outside of Sample"><em class="italic">Endnotes</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?10c38868